import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { sankey as d3Sankey, sankeyLinkHorizontal } from "d3-sankey";

const SankeyChart = ({ data, width = 700, height = 400 }) => {
  const svgRef = useRef();
  const tooltipRef = useRef();

  useEffect(() => {
    if (!data) return;

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    const sankey = d3Sankey()
      .nodeWidth(15)
      .nodePadding(15)
      .size([width, height]);

    const { nodes, links } = sankey(data);

    const tooltip = d3.select(tooltipRef.current);

    // Enlaces    
    svg
      .append("g")
      .selectAll("path")
      .data(links)
      .enter()
      .append("path")
      .attr("d", sankeyLinkHorizontal())
      .attr("fill", "none")
      .attr("stroke", "#8787fb")
      .attr("stroke-width", (d) => Math.max(1, d.width))
      .attr("opacity", 0.7);

    // Nodos
    const node = svg
      .append("g")
      .selectAll("rect")
      .data(nodes)
      .enter()
      .append("rect")
      .attr("x", (d) => d.x0)
      .attr("y", (d) => d.y0)
      .attr("height", (d) => d.y1 - d.y0)
      .attr("width", sankey.nodeWidth())
      .attr("fill", "#6565ff")
      .on("mouseover", function (event, d) {
        d3.select(this).attr("fill", "#4040fb"); // Hover

        // Muestra el tooltip
        tooltip
          .style("visibility", "visible")
          .html(
            `<strong>${d.name}</strong><br/>
         Valor: ${d.value}<br/>
         Extra Info: Detalle aquí`
          )
          .style("top", `${event.pageY - 10}px`)
          .style("left", `${event.pageX + 10}px`);
      })
      .on("mousemove", function (event) {
        tooltip
          .style("top", `${event.pageY - 10}px`)
          .style("left", `${event.pageX + 10}px`);
      })
      .on("mouseout", function (event, d) {
        d3.select(this).attr("fill", "#6565ff");
        tooltip.style("visibility", "hidden");
      });


    // Etiquetas
    const text = svg
      .append("g")
      .selectAll("text")
      .data(nodes)
      .enter()
      .append("text")
      .attr("x", (d) => d.x0 - 10)
      .attr("y", (d) => (d.y0 + d.y1) / 2)
      .attr("dy", "0.35em")
      .attr("text-anchor", "end")
      .attr("font-size", "14px")
      .attr("fill", "#333")
      .attr("font-weight", "bold");

    text.append("tspan").text((d) => d.name);
    text
      .append("tspan")
      .text((d) => `Valor: ${d.value}`)
      .attr("x", (d) => d.x0 - 10)
      .attr("dy", "1.2em");

  }, [data, width, height]);

  return (
    <>
      <svg ref={svgRef} width={width} height={height} />
      <div
        ref={tooltipRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          background: "rgba(0,0,0,0.7)",
          color: "white",
          padding: "5px",
          borderRadius: "5px",
          fontSize: "12px",
        }}
      />
    </>
  );
};

export default SankeyChart;